import { useState } from "react"
import { Button } from "@/shared/ui/button"
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/shared/ui/dialog"
import { Input } from "@/shared/ui/input"

export function NameDialog({
	title,
	initial,
	open,
	onOpenChange,
	onSubmit,
}: {
	title: string
	initial: string
	open: boolean
	onOpenChange: (open: boolean) => void
	onSubmit: (name: string) => Promise<void>
}) {
	const [name, setName] = useState(initial)
	return (
		<Dialog
			open={open}
			onOpenChange={(next) => {
				if (next) setName(initial)
				onOpenChange(next)
			}}
		>
			<DialogContent className="sm:max-w-md">
				<DialogHeader>
					<DialogTitle>{title}</DialogTitle>
				</DialogHeader>
				<form
					className="space-y-4"
					onSubmit={(event) => {
						event.preventDefault()
						if (name.trim()) void onSubmit(name.trim())
					}}
				>
					<Input
						autoFocus
						aria-label="Название воронки"
						placeholder="Например, Приветствие"
						maxLength={64}
						value={name}
						onChange={(event) => setName(event.target.value)}
					/>
					<DialogFooter>
						<Button type="submit" disabled={!name.trim()}>
							Сохранить
						</Button>
					</DialogFooter>
				</form>
			</DialogContent>
		</Dialog>
	)
}
